import { render, staticRenderFns } from "./LabelWithValue.vue?vue&type=template&id=9d490d90&scoped=true"
import script from "./LabelWithValue.vue?vue&type=script&lang=ts"
export * from "./LabelWithValue.vue?vue&type=script&lang=ts"
import style0 from "./LabelWithValue.vue?vue&type=style&index=0&id=9d490d90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d490d90",
  null
  
)

export default component.exports